import React from "react";
import Column from "@amzn/meridian/column";
import {ModalFooter} from "@amzn/meridian/modal";
import {FormattedMessage, injectIntl} from "react-intl";
import Alert from "@amzn/meridian/alert";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import PropTypes from "prop-types";

export const PageFooterModal = (props) => {

    const {showAlert, onCloseModalCallBack, onClickConfirmCallBack} = props;

    const onCloseModal = () => {
        onCloseModalCallBack();
    };

    const onClickConfirm = () => {
        onClickConfirmCallBack();
    };

    return (
        <ModalFooter>
            <Column>
                {showAlert && <Alert type="warning" size="small">
                    <FormattedMessage id="alert.missingfields"
                                      defaultMessage="Please enter all fields in correct format!"/>
                </Alert>}
            </Column>
            <Row alignmentHorizontal="right" widths="fit">
                <Button type="secondary" size="medium" onClick={onCloseModal}>
                    <FormattedMessage id="modal.cancel" defaultMessage="Cancel"/>
                </Button>
                <Button type="primary"
                        size="medium"
                        onClick={() => onClickConfirm()}>
                    {<FormattedMessage id="modal.confirmAdd" defaultMessage="Confirm add"/>}
                </Button>
            </Row>
        </ModalFooter>
    )
}

PageFooterModal.propTypes = {
    showAlert: PropTypes.bool.isRequired,
    onCloseModalCallBack: PropTypes.func.isRequired,
    onClickConfirmCallBack: PropTypes.func.isRequired
};

export default injectIntl(PageFooterModal);


// WEBPACK FOOTER //
// ./src/components/commonui/PageFooterModal.js